import React from 'react';
import Helmet from 'react-helmet';
import {Inertia} from '@inertiajs/inertia';
import {InertiaLink, usePage, useForm} from '@inertiajs/inertia-react';
import Layout from '@/Shared/Layout';
import DeleteButton from '@/Shared/DeleteButton';
import LoadingButton from '@/Shared/LoadingButton';
import TextInput from '@/Shared/TextInput';
import SelectInput from '@/Shared/SelectInput';
import TrashedMessage from '@/Shared/TrashedMessage';

const Edit = () => {
    const {publication} = usePage().props;
    const {data, setData, errors, put, processing} = useForm(()=>{

        return {
            title: publication.data.title || '',
            title_en: publication.data.title_en || '',
            description: publication.data.description || '',
            doi: publication.data.doi || '',
            journal: publication.data.journal || '',
            year: publication.data.year || '',
            authors: publication.data.authors || '',
            url: publication.data.url || '',
        }
    });

    function handleSubmit(e) {
        e.preventDefault();
        put(route('publications.update', publication.data.id));
    }

    function destroy() {
        if (confirm('Are you sure you want to delete this publication?')) {
            Inertia.delete(route('publications.destroy', publication.data.id));
        }
    }



    return (
        <div>

            {/*<h1 className="mb-8 text-3xl font-bold">*/}
            {/*    <InertiaLink*/}
            {/*        href={route('publications')}*/}
            {/*        className="text-indigo-600 hover:text-indigo-700"*/}
            {/*    >*/}
            {/*        Publications*/}
            {/*    </InertiaLink>*/}
            {/*    <span className="mx-2 font-medium text-indigo-600">/</span>*/}
            {/*    {data.title}*/}
            {/*</h1>*/}

            <div className="">
                <form onSubmit={handleSubmit}>
                    <div className="flex flex-wrap p-8 ">
                        <TextInput
                            className="w-full pb-8 pr-6 "
                            label="title"

                            type="text"
                            name="title"
                            errors={errors.title}
                            value={data.title}
                            onChange={e => setData('title', e.target.value)}
                        />
                        <TextInput
                            className="w-full pb-8 pr-6 "
                            label="Title EN"

                            type="text"
                            name="title_en"
                            errors={errors.title_en}
                            value={data.title_en}
                            onChange={e => setData('title_en', e.target.value)}
                        />
                        <TextInput
                            className="w-full pb-8 pr-6 "
                            label="Description"
                            name="description"

                            type="text"
                            errors={errors.description}
                            value={data.description}
                            onChange={e => setData('description', e.target.value)}
                        />
                        <TextInput
                            className="w-full pb-8 pr-6 "
                            label="Year"
                            name="year"

                            type="text"
                            errors={errors.year}
                            value={data.year}
                            onChange={e => setData('year', e.target.value)}
                        />
                        <TextInput
                            className="w-full pb-8 pr-6"
                            label="URL"
                            name="url"
                            type="text"

                            errors={errors.url}
                            value={data.url}
                            onChange={e => setData('url', e.target.value)}
                        />
                        <TextInput
                            className="w-full pb-8 pr-6 "
                            label="Journal"
                            name="journal"
                            type="text"
                            errors={errors.journal}
                            value={data.journal}
                            onChange={e => setData('journal', e.target.value)}
                        />
                        <TextInput
                            className="w-full pb-8 pr-6"
                            label="Authors"
                            name="authors"
                            type="text"
                            errors={errors.authors}
                            value={data.authors}
                            onChange={e => setData('authors', e.target.value)}
                        />
                        <TextInput
                            className="w-full pb-8 pr-6 "
                            label="DOI"
                            name="doi"
                            type="text"
                            errors={errors.doi}
                            value={data.doi}
                            onChange={e => setData('doi', e.target.value)}


                        />
                    </div>
                    <div className="flex items-center px-8 py-4 bg-gray-100 border-t border-gray-200">
                        {!publication.deleted_at && (
                            <DeleteButton onDelete={destroy}>Delete Publication</DeleteButton>
                        )}
                        <LoadingButton
                            loading={processing}
                            type="submit"
                            className="ml-auto btn-indigo"
                        >
                            Update Publication
                        </LoadingButton>
                    </div>
                </form>
            </div>
        </div>
    );
};

Edit.layout = page => <Layout children={page}/>;
export default Edit;
